'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _UpOutlined = _interopRequireDefault(require('./lib/icons/UpOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _UpOutlined;
exports.default = _default;
module.exports = _default;